































































































































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import ProgressQuestion from '../atoms_molecules/ProgressQuestion.vue'
import SlideBar from '../atoms_molecules/SlideBar.vue'
import { checkMobile } from '../../utils/utils'
import ChartProgress from '../atoms_molecules/ChartProgress.vue'
import { ROUTER_NAME } from '../../router'
import { find } from 'lodash'
import AsForm from '../../../api/v2/forms/as'
import Exam from '../../models/exam'
import { differenceInSeconds } from 'date-fns'
import ExamStatusForm from '../../../api/v2/forms/answer_status'
import { LETTER_FORMAT } from '../../utils/constants'
import Question from '../../models/question'
import ExamTestQuestionBodyWeb from '../atoms_molecules/ExamTestQuestionBodyWeb.vue'
import ExamTestQuestionBodyMobile from '../atoms_molecules/ExamTestQuestionBodyMobile.vue'
import QuestionGroupTestList from '../atoms_molecules/QuestionGroupTestList.vue'
import { GroupQuestion } from '../../../api/v2/models/question'
import hotkeys from 'hotkeys-js'
import ExamResultQuestionBodyWeb from '../atoms_molecules/ExamResultQuestionBodyWeb.vue'
import ExamResultQuestionBodyMobile from '../atoms_molecules/ExamResultQuestionBodyMobile.vue'
import ExamTimer from '../atoms_molecules/ExamTimer.vue'
import ButtonReload from '../atoms_molecules/ButtonReload.vue'
import HeaderUser from '../organisms/HeaderUser.vue'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import { focusMathliveElement } from '../../../../lib/mathlive'
import { examTestState } from '../../stores/exam_test'
import { Route } from 'vue-router'
import { EMBED_ROUTER_NAME } from '../../../embed/router'
import { userState } from '../../stores/user'

class QuestionValueForm {
  public value: string[] = []
  public text: string = ''

  constructor(public readonly question: Question) {}
}

const DefaultFooterMobile = () => {
  return {
    color: '#7DD420',
    show: true,
    default: {
      show: false
    },
    buttons: {
      show: true,
      items: []
    }
  }
}

@Component({
  components: {
    ProgressQuestion,
    SlideBar,
    ChartProgress,
    ExamTimer,
    ExamTestQuestionBodyWeb,
    ExamTestQuestionBodyMobile,
    QuestionGroupTestList,
    ExamResultQuestionBodyWeb,
    ExamResultQuestionBodyMobile,
    ButtonReload,
    HeaderUser
  }
})
export default class QuestionComponent extends Vue {
  get schoolSetting() {
    return headerState.schoolSetting
  }
  get exam() {
    return examTestState.exam
  }
  get user() {
    return userState.user
  }
  get userExam(){
    if (!this.userExamId) {
      return this.exam.userExam
    }

    const userExam = this.exam.userExams.find(item => item.id == parseInt(this.userExamId as string))
    return userExam
  }
  get userExamId(){
    return this.$route.query['user_exam_id']
  }
  get redirectNotFoundPage() {
    return examTestState.redirectNotFoundPage
  }
  get examTestQuestionsAnswered() {
    return examTestState.examTestQuestionsAnswered
  }
  get groupExamTestQuestions() {
    return examTestState.groupExamTestQuestions
  }
  get groupQuestions() {
    return examTestState.groupQuestions
  }
  get headerNavTextColor() {
    if (this.schoolSetting){
      return this.schoolSetting.navTextColor
    }
  }

  getGlobalCss() {
    return this.exam.globalCss
  }

  applyGlobalCss() {
    const style = document.createElement('style')
    style.textContent = this.getGlobalCss()
    document.head.appendChild(style)
  }

  getQuestionNumber(groupExamTestQuestion) {
    return (
      this.groupExamTestQuestions
        .filter((item) => item.questions.every((question) => !question.isDescriptionQuestion))
        .indexOf(groupExamTestQuestion) + 1
    )
  }

  confimDialog = false

  groupQuestion: GroupQuestion = new GroupQuestion(-1, [])

  reRender: string = Date().toString()
  LETTER_FORMAT = LETTER_FORMAT
  //To Fix bug  https://github.com/happa/skillhub/issues/719
  isShowBody = true
  questionValueForms: QuestionValueForm[] = []
  mobile = checkMobile()
  find = find
  timer = null
  time = 0
  timeOut = false
  questionNumber: number = 0
  isReport = false

  @Watch('groupQuestion')
  watchgroupQuestion() {
    this.questionValueForms = []
    if (this.groupQuestion) {
      this.groupQuestion.questions.forEach((question) => {
        this.questionValueForms.push(new QuestionValueForm(question))
      })
    }

    setTimeout(() => {
      if (this.groupQuestion && this.groupQuestion.questions[0]) {
        this.focusQuestion(this.groupQuestion.questions[0])
      }
    }, 500)

    this.updateMobileBar()
  }

  focusQuestion(question: Question) {
    const elm = document.getElementById(`question_${question.id}`)
    if (!elm) {
      return
    }

    if (question.isTextarea) {
      const simplemde = this.getSimplemde(question)
      if (simplemde) {
        simplemde.codemirror.focus()
        simplemde.codemirror.setCursor({ line: 1, ch: 5 })
      }
    } else {
      const inputElm = elm.getElementsByTagName('INPUT')[0] as HTMLInputElement
      if (inputElm) {
        focusMathliveElement(inputElm)
        window.scrollTo(0, 0)
      }
    }
  }

  getRateScore(score, maxScore) {
    if (maxScore == 0) {
      return 0
    }
    return Math.round((score / maxScore) * 100)
  }

  confimSubmit() {
    this.confimDialog = false
    this.showResult()
  }

  get userScore() {
    return this.groupQuestion.userScore
  }

  get maxScore() {
    return this.groupQuestion.maxScore
  }

  // Todo: いい方法を考えます
  getSimplemde(question: Question): any {
    const questionElm = this.$refs[`question_${question.id}`][0]
    if (!questionElm) {
      return null
    }

    const questionBodyElm = questionElm.$refs[`markdownEditor_q_${question.id}`]
    if (!questionBodyElm) {
      return null
    }

    const markdownEditor = questionBodyElm.$refs[`markdownEditor_q_${question.id}`]
    if (!markdownEditor) {
      return null
    }

    return markdownEditor.simplemde
  }

  callBackChange(value: string[], question: Question) {
    const questionValueForm = this.questionValueForms.find((item) => item.question.id == question.id)
    if (questionValueForm) {
      questionValueForm.value = value
      questionValueForm.text = value.length ? value[0] : ''
    }
  }

  toExamShow() {
    if (this.user.isGuestExamOnly) {
      location.href = `/exams/${this.$route.params.examId}`
      return
    }

    this.$router.push({
      name: ROUTER_NAME.EXAM_SHOW,
      params: {
        examId: this.$route.params.examId
      },
      query: this.$route.query
    })
  }
  toExamQuestionList() {
    this.$router.push({
      name: ROUTER_NAME.EXAM_QUESTION_LIST,
      params: {
        examId: this.$route.params.examId
      },
      query: this.$route.query
    })
  }

  @Watch('exam', { immediate: true })
  async changeExam(exam) {
    if (!exam) {
      return
    }
    examTestState.setUserExamId(this.userExam.id)
    await examTestState.getExamTestQuestions()
    examTestState.requestExamGroupQuestion(parseInt(this.$route.params.questionId)).then((groupQuestion) => {
      this.groupQuestion = groupQuestion
      this.updateData(exam, this.$route)
    })
  }

  @Watch('$route')
  changeRoute(val) {
    this.isShowBody = false
    this.isReport = false
    setTimeout(() => {
      this.isShowBody = true
      window.scrollTo(0, 0)
    }, 100)

    if (this.mobile) {
      var date = new Date()
      this.reRender = date.getTime().toString()
    }

    examTestState.requestExamGroupQuestion(parseInt(this.$route.params.questionId)).then((groupQuestion) => {
      this.groupQuestion = groupQuestion
    })

    if (document.getElementsByClassName('question-content-show').length) {
      document.getElementsByClassName('question-content-show')[0].scrollTop = 0
    }

    this.updateData(this.exam, val)
  }

  @Watch('redirectNotFoundPage')
  changeRedirectNotFoundPage(val, oldVal) {
    if (val) {
      examTestState.setRedirectNotFoundPage({ status: false })
      this.redirectToNotFoundPage()
    }
  }

  redirectToNotFoundPage() {
    this.$router.push({
      name: ROUTER_NAME.NOT_FOUND
    })
  }

  redirectToExamResult() {
    this.$router.push({
      name: ROUTER_NAME.EXAM_RESULT,
      params: {
        examId: this.$route.params.examId,
      },
      query: {
        user_exam_id: this.userExam.id.toString()
      }
    })
  }

  redirectToExamList() {
    this.$router.push({
      name: ROUTER_NAME.MY_EXAM_LIST
    })
  }

  updateData(exam: Exam | undefined, route: Route) {
    if (!exam) {
      return
    }

    this.applyGlobalCss()

    if (exam.isDone(this.userExam) && this.userExam.isWaitingScoreCheck) {
      this.redirectToExamList()
      return
    }

    if (this.userExam.finishedAt) {
      this.redirectToExamResult()
      return
    }

    // 別のページ移動した時に、現在の処理を更新しません
    if (route.name == ROUTER_NAME.QUESTION) {
      const questionIndex = this.userExam.questions.findIndex((item) => item.id.toString() == route.params.questionId)
      if (questionIndex == -1) {
        this.redirectToNotFoundPage()
      }
    }
    this.questionNumber = exam.getQuestionNumberById(parseInt(route.params.questionId))
    this.updateMobileBar()
    this.time = exam.timeLimit * 60 - differenceInSeconds(new Date(), this.userExam.startedAt)
    this.time = this.time > 0 ? this.time : 0
    if (this.time <= 0) {
      this.timeOut = true
    }
  }

  updateMobileBar() {
    // footerStateは共通データなので、別のページ移動した時に、現在のStateを更新しません
    if (this.mobile && this.$route.name === ROUTER_NAME.QUESTION && this.exam) {
      const questionIndex = this.userExam.questions.findIndex(
        (item) => item.id.toString() == this.$route.params.questionId
      )
      const footerMobile = DefaultFooterMobile()
      footerMobile.buttons.items = this.getFooterItems(this.userExam.questions.length, questionIndex)
      footerState.setFooter(footerMobile)
    }
  }

  get headerTitle() {
    return this.questionNumber ? '問題 ' + this.questionNumber : '説明'
  }

  get buttonHandler() {
    if (this.isReport) {
      return {
        label: '提出する',
        action: () => {
          this.confimDialog = true
        }
      }
    }

    if (this.groupQuestion.isDescriptionQuestion) {
      return {
        label: '次の質問へ',
        action: this.next
      }
    }

    if (this.isAnswered) {
      if (this.isLastItem && this.isFullAnswered) {
        return {
          label: 'ステータスを確認する',
          action: this.next
        }
      }

      if (this.exam.isResultAfterQuestion) {
        return {
          label: '次の質問へ',
          action: this.next
        }
      }
    }

    return {
      label: '回答',
      action: this.saveAndNext
    }
  }

  getFooterItems(count, index) {
    return [
      {
        round: true,
        color: 'white',
        label: '＜＜',
        action: this.first,
        disabled: index <= 0
      },
      {
        round: true,
        color: 'white',
        label: '＜',
        action: this.previous,
        disabled: index <= 0
      },
      {
        round: true,
        color: 'white',
        label: this.buttonHandler.label,
        action: this.buttonHandler.action,
        disabled: this.groupQuestion.isDescriptionQuestion && index + 1 >= count
      },
      {
        round: true,
        color: 'white',
        label: '＞',
        action: index + 1 >= count ? this.showFinal : this.next
      },
      {
        round: true,
        color: 'white',
        label: '＞＞',
        action: this.showFinal
      }
    ]
  }

  public mounted() {
    examTestState.requestExamTest(parseInt(this.$route.params.examId))
    this.watchgroupQuestion()
    this.settupHotKeys()
  }

  settupHotKeys() {
    this.removeHotkeys()

    hotkeys.filter = (event) => {
      return true
    }

    hotkeys('ctrl+enter, command+enter', 'exams', () => {
    // hotkeys('enter', 'exams', () => {
      this.buttonHandler.action()
    })

    hotkeys('ctrl+shift+right, control+shift+right', 'exams', () => {
      this.next()
    })
    hotkeys('ctrl+shift+left, control+shift+left', 'exams', () => {
      this.previous()
    })

    // hotkeys('alt+right', 'exams', () => {
    //   this.next()
    // })

    // hotkeys('alt+shift+right', 'exams', () => {
    //   this.last()
    // })

    // hotkeys('alt+shift+left', 'exams', () => {
    //   this.first()
    // })

    // hotkeys('alt+left', 'exams', () => {
    //   this.previous()
    // })



    hotkeys.setScope('exams')
  }

  removeHotkeys() {
    hotkeys.deleteScope('exams')
  }

  beforeDestroy() {
    this.removeHotkeys()
  }

  async showResult() {
    const examStatusForm = new ExamStatusForm()
    examStatusForm.examId = this.exam.id
    examStatusForm.isFinishExam = true
    examStatusForm.userExamId = this.userExam.id
    await examTestState.saveExamStatus({ examStatusForm })
    this.timeOut = false
  }

  async saveForm(questionValueForm: QuestionValueForm) {
    if (questionValueForm.question && questionValueForm.question.isTextfield) {
      const textfieldQuestions = document
        .getElementById(`question_${questionValueForm.question.id}`)
        .querySelectorAll('.textfield-question')
      questionValueForm.value = []
      for (let index = 0; index < textfieldQuestions.length; index++) {
        questionValueForm.value.push((textfieldQuestions[index] as HTMLInputElement).value)
      }
    }

    if (questionValueForm.question && questionValueForm.question.isInlineSelect) {
      const inlineSelectQuestions = document
        .getElementById(`question_${questionValueForm.question.id}`)
        .querySelectorAll('.inline-select-question')
      questionValueForm.value = []
      for (let index = 0; index < inlineSelectQuestions.length; index++) {
        questionValueForm.value.push((inlineSelectQuestions[index] as HTMLInputElement).value)
      }
    }

    if (!questionValueForm.question.isDescriptionQuestion && questionValueForm.value.length && this.time > 0) {
      const answerForm = new AsForm()
      answerForm.examId = this.exam.id
      answerForm.qId = questionValueForm.question.id.toString()
      answerForm.userExamId = this.userExam.id
      // Add multy value TODO
      answerForm.answers = questionValueForm.value
      await examTestState.saveAnswer({ answerForm }).then((groupQuestion) => {
        if (groupQuestion) {
          this.groupQuestion = groupQuestion
        }
        this.changeExam(this.exam)
      })
      let asIds: number[] = this.groupQuestion.questions.flatMap((question) =>
        question.answers.map((answer) => answer.id)
      )
      examTestState.saveAiGrade(asIds, answerForm).then((groupQuestion) => {
        if (groupQuestion) {
          this.groupQuestion = groupQuestion;
        }
        this.changeExam(this.exam);
      });
    }
  }

  async saveAndNext() {
    if (this.groupQuestion.isDescriptionQuestion) {
      await this.next()
      return
    }

    await this.questionValueForms.forEach(async (questionValueForm) => {
      await this.saveForm(questionValueForm)
    })

    if (this.exam.isResultAfterSubmit) {
      this.next()
    }
  }

  get groupIndex(): number {
    for (let index = 0; index < this.groupExamTestQuestions.length; index++) {
      const groupExamTestQuestion = this.groupExamTestQuestions[index]
      if (groupExamTestQuestion.groupId == this.groupQuestion.groupId) {
        return index
      }
    }
    return -1
  }

  get isLastItem() {
    return this.groupIndex === this.groupExamTestQuestions.length - 1
  }

  get isFirstItem() {
    return this.groupIndex === 0
  }

  get isExamResultAfterQuestion() {
    return this.exam.isResultAfterQuestion && this.isAnswered
  }

  get isAnswered() {
    return !!this.examTestQuestionsAnswered.find((item) => item.id == parseInt(this.$route.params.questionId))
  }

  get isFullAnswered(){
    return this.groupQuestion.questions.every(question => !!this.examTestQuestionsAnswered.find((item) => item.id == question.id))
  }

  next() {
    if (this.isLastItem) {
      if (this.mobile) {
        this.showFinal()
      } else {
        this.isReport = true
      }
      return
    }
    this.goQuestion(this.groupExamTestQuestions[this.groupIndex + 1].questions[0].id)
  }

  previous() {
    if (this.isFirstItem) {
      return
    }
    this.goQuestion(this.groupExamTestQuestions[this.isReport ? this.groupIndex : this.groupIndex - 1].questions[0].id)
  }

  first() {
    this.goQuestion(this.groupExamTestQuestions[0].questions[0].id)
  }

  last() {
    if (this.isLastItem && !this.mobile) {
      this.isReport = true
    } else {
      this.goQuestion(this.groupExamTestQuestions[this.groupExamTestQuestions.length - 1].questions[0].id)
    }
  }

  goQuestion(questionId: number) {
    if (this.isReport) {
      this.isReport = false
    }
    if (questionId != parseInt(this.$route.params.questionId)) {
      this.$router.push({
        name: ROUTER_NAME.QUESTION,
        params: {
          examId: `${this.exam.id}`,
          questionId: `${questionId}`
        },
        query: this.$route.query
      })
    }
  }

  showFinal() {
    this.$router.push({
      name: ROUTER_NAME.EXAM_QUESTION_LIST,
      params: {
        examId: this.$route.params.examId
      },
      query: this.$route.query
    })
  }

  updateIsReport() {
    this.isReport = false
  }

  changeQuestion(slideIndex) {
    if (slideIndex > 1) {
      this.next()
    }
    if (slideIndex < 1 && !this.isFirstItem) {
      this.previous()
    }

    ;(this.$refs.swipe as any).goto(1)
  }
  reload() {
    this.$router.go(this.$router.currentRoute as any)
  }

  handleTimeUp() {
    if (!this.timeOut) {
      this.timeOut = true;
      clearInterval(this.timer);
    }
  }
}
